/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Program3, Program3FromJSON, Program3ToJSON } from './'

/**
 *
 * @export
 * @interface Student
 */
export interface Student {
  /**
   * The unique identifier of the student.
   * @type number
   * @memberof Student
   */
  studentKey: number
  /**
   * The first name of the student.
   * @type string
   * @memberof Student
   */
  firstName: string
  /**
   * The last name of the student.
   * @type string
   * @memberof Student
   */
  lastName?: string
  /**
   * The date of birth of the student.
   * @type Date
   * @memberof Student
   */
  dateOfBirth: Date
  /**
   * The number indicating student's month of birth. Indexed from 0 to 11.
   * @type number
   * @memberof Student
   */
  birthMonth?: number
  /**
   * The number indicating student's year of birth.
   * @type number
   * @memberof Student
   */
  birthYear?: number
  /**
   * Indicates if the student is hidden.
   * @type boolean
   * @memberof Student
   */
  hidden: boolean
  /**
   * The unique identifier of the parent user associated with the student.
   * @type number
   * @memberof Student
   */
  parentUserKey?: number
  /**
   * The programs a student has been associated to.
   * @type {Array<Program3>}
   * @memberof Student
   */
  programs: Array<Program3>
}

export function StudentFromJSON(json: any): Student {
  return StudentFromJSONTyped(json, false)
}

export function StudentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Student {
  if (json === undefined || json === null) {
    return json
  }
  return {
    studentKey: json['studentKey'],
    firstName: json['firstName'],
    lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
    dateOfBirth: new Date(json['dateOfBirth']),
    birthMonth: !exists(json, 'birthMonth') ? undefined : json['birthMonth'],
    birthYear: !exists(json, 'birthYear') ? undefined : json['birthYear'],
    hidden: json['hidden'],
    parentUserKey: !exists(json, 'parentUserKey')
      ? undefined
      : json['parentUserKey'],
    programs: (json['programs'] as Array<any>).map(Program3FromJSON),
  }
}

export function StudentToJSON(value?: Student | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    studentKey: value.studentKey,
    firstName: value.firstName,
    lastName: value.lastName,
    dateOfBirth: value.dateOfBirth.toISOString().substr(0, 10),
    birthMonth: value.birthMonth,
    birthYear: value.birthYear,
    hidden: value.hidden,
    parentUserKey: value.parentUserKey,
    programs: (value.programs as Array<any>).map(Program3ToJSON),
  }
}
